import 'antd/dist/antd.css';
import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import DashboardTemplate from './DashboardTemplate';
import LeftSidebarContent from './LeftSidebarContent';
import RightSidebarContent from './RightSidebarContent';
import styles from './styles';
import { getUser } from '../../reducers';
import Loading from 'react-fullscreen-loading';
import {
  getMapLoadingState,
  getFilterType,
  getFilteringDateRange,
  getSelectedState,
  getHelpPopUpStatus,
  getFilteringState
} from './reducers';
import {
  change_date_range,
  change_filter_type,
  fetch_country_details,
  change_help_popup_state
} from './actions';
import { backward_fetch_by_selected_state } from './LeftSidebarContent/actions';
import { me } from '../../actions';
import Map from './Map';
import PopUpDetailsContent from './PopUpDetailsContent';
import Help from '../Help';

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingAssets: false,
      fromDate: null,
      toDate: null
    };
  }

  componentDidMount() {
    this.props.fetchUser();
  }

  showLoader = () => {
    this.setState({
      loadingAssets: true
    });
  };

  hideLoader = () => {
    this.setState({
      loadingAssets: false
    });
  };

  renderLeftSidebars = () => {
    return (
      <React.Fragment>
        <LeftSidebarContent
          onCbButtonClick={this.onCbButtonClick}
          onHelpButtonClick={this.onHelpButtonClick}
          onHomeButtonClick={this.onHomeButtonClick}
          onBackButtonClick={this.onBackButtonClick}
        />
      </React.Fragment>
    );
  };

  renderRightSidebars = () => {
    const { selectedState } = this.props;
    return (
      <React.Fragment>
        <RightSidebarContent
          selectedState={selectedState}
          defaultDateRange={this.props.dateRange}
          actionOnDateChange={this.onChangeDate}
          defaultFilterType={this.props.filterType}
          actionOnTypeChange={this.onChangeType}
        />
      </React.Fragment>
    );
  };

  onChangeDate = (date, dateString) => {
    this.props.changeDateRange(date);
  };

  onChangeType = type => {
    this.props.changeType(type);
  };

  onHelpButtonClick = () => {
    this.props.changeHelpPopupState(true);
  };

  onBackButtonClick = () => {
    this.props.backwardFetchBySelectedState(this.props.selectedState);
  };

  onHomeButtonClick = () => {
    this.props.fetchCountryDetails();
  };

  onCbButtonClick = () => {
    this.props.history.push('/cb');
  };

  componentDidUpdate(prevProps) {
    if (
      prevProps.router.location.pathname ===
        this.props.router.location.pathname &&
      prevProps.router.location.key !== this.props.router.location.key
    ) {
      window.location.reload();
    }
  }

  render() {
    const { classes, user } = this.props;
    return (
      user && (
        <DashboardTemplate>
          <Loading
            loading={this.props.mapLoading}
            background="rgba(52, 52, 52, 0.75)"
            loaderColor="#3498db"
          />

          {this.renderLeftSidebars()}

          <div className={classes.map}>
            <Map />
            <PopUpDetailsContent />
            <Help
              open={this.props.helpPopUpStatus}
              onClickClose={() => {
                this.props.changeHelpPopupState(false);
              }}
              state={this.props.filteringState}
            />
          </div>

          {this.renderRightSidebars()}
        </DashboardTemplate>
      )
    );
  }
}

const mapStateToProps = state => ({
  user: getUser(state),
  router: state.router,
  mapLoading: getMapLoadingState(state),
  filterType: getFilterType(state),
  dateRange: getFilteringDateRange(state),
  selectedState: getSelectedState(state),
  helpPopUpStatus: getHelpPopUpStatus(state),
  filteringState: getFilteringState(state)
});

const mapDispatchToProps = dispatch => ({
  fetchUser: () => dispatch(me()),
  goToRoot: () => dispatch(push('/')),
  changeDateRange: date_range => dispatch(change_date_range(date_range)),
  changeHelpPopupState: value => dispatch(change_help_popup_state(value)),
  changeType: type => dispatch(change_filter_type(type)),
  fetchCountryDetails: () => dispatch(fetch_country_details()),
  backwardFetchBySelectedState: selectedState =>
    dispatch(backward_fetch_by_selected_state(selectedState))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Dashboard));
